import { css } from 'styled-components';

export const paginationFooterFixedUiClearance = css`
  padding-inline-end: calc(72px + env(safe-area-inset-right, 0px));
`;
